export const PATH = {
    dashboard: '/',
    wallet: '/wallet',
    walletAction: '/wallet/:action',
    reports: '/reports',
    markets: '/markets',
    trade: '/trade',
    cards: '/cards',
    profile: '/profile',
    security: '/security',
    referral: '/referral',
    ticket: '/ticket',
    ticketById: '/ticket/:ticketId',
    kycVerify: '/kyc/verify',
    paymentGatewayVerifyBuy: '/verify/buy/:trackingCode',
    paymentGatewayVerifyWallet: '/verify/irt/:trackingCode',
    notFound: '/404',
    contact: 'https://30pay.me',
    rules: 'https://30pay.me/rules',
};
